import store from '@/store';
import router from '@/router';

export default function setup(axios) {
    // add auth token to requests
    axios.interceptors.request.use(
        config => {
            // Put token auth token in request headers
            const token = store.getters['auth/token'];
            if (token) {
                config.headers['Authorization'] = `Token ${token}`;
            }
            return config;
        },
        err => {
            return Promise.reject(err);
        }
    );

    // Response
    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            const { response } = error;
            // Handle response error
            if (response && (response.status > 400 && response.status < 404)) {
                // If the token/cookie we are using stops working, log out
                store.dispatch('auth/logout');
            }
            // unwrap the axios error object so we can get at the error message
            return Promise.reject(response);
        }
    );
}
